import React, { Component } from 'react';

import {c_light} from '../a-Graphic/Colors';

class Table extends React.Component {

  render() {
    let lines = [];
    for (let i=0; i<this.props.tables[0].length; i++){
      lines.push(this.props.tables.map((t) => t[i]))
    }


    return(
      <div class="col">
        <div class="row">
        </div>
        <div class="row" style={{height: this.props.height, overflow: "auto"}}>
          <table class="table table-sm table-hover">
            <thead>
              <tr>
              {this.props.headlines.map((h) =>
                <th scope="col">{h}</th>
              )}
              </tr>
            </thead>
            <tbody>

            {lines.map((l) =>
              <tr>
                {
                  l.map((item, i)=>
                   this.props.align[i]=="r" ?
                     <td class="text-right">{item}</td> :
                     <td>{item}</td>

                )
                }
              </tr>
            )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Table;
